// Pure-CSS illustration evoking a stack of audit-log entries (user · action · timestamp),
// fading out towards the bottom.
export function AuditLogEmptyState() {
  return (
    <div className="mb-6 flex w-2xs flex-col gap-2 mask-b-from-30%">
      {[0, 1, 2].map((i) => (
        <div key={i} className="flex items-center gap-3 rounded-lg border bg-gray-50 p-2.5 shadow-lg/3">
          <div className="size-6 shrink-0 rounded-full border-2 border-gray-300 bg-white"></div>
          <div className="grow">
            <div className="mb-1 h-2.5 w-2/3 rounded-sm bg-gray-200/80"></div>
            <div className="h-2 w-1/3 rounded-sm bg-gray-200/50"></div>
          </div>
          <div className="h-2 w-7 shrink-0 rounded-sm bg-gray-200/60"></div>
        </div>
      ))}
    </div>
  );
}
